export default __webpack_public_path__ + "static/media/planet-lg.26556c41.svg";